import { createStore } from "vuex";
import router from "@/router";
import axios from "axios";
export default createStore({
  state: {
    liveMode: true,
    plans: [],
    heading: {
      single: "Lions Single Game Tickets",
      "large-group": "Lions Group Tickets",
      "multi-game-plans": "Multi-Game Plans",
    },
    cta: {
      single: "Choose the Best Game for You",
      "large-group": "Build Your Custom Group Outing",
      "multi-game-plans": "Choose the Type of Plan",
    },
    disclaimer: {
      "Lions Loyal Plans":
        "Pricing per month based off a 12 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Reserve Membership":
        "Pricing per month based off a 12 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Club Membership":
        "Pricing per month based off a 12 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Mini-Plans":
        "Pricing per month based off an 8 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Blue Mini-Plan":
        "Pricing per month based off an 8 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Silver Mini-Plan":
        "Pricing per month based off an 8 month payment plan. Pricing per month may vary depending on date of purchase.",
      "Stadium Passes": "",
    },
    activePlan: "",
    API_URL: "https://ticketfinder.detroitlions.com/admin/api",
    ASSET_URL: "https://ticketfinder.detroitlions.com",
    // API_TOKEN:
    //   "bb1a5a2e2b5b08b2c2bfbbecdd2802&previewToken=a3d5a5ea029e97b5ac31a327e1803b",
    API_TOKEN: "bb1a5a2e2b5b08b2c2bfbbecdd2802&previewToken=a3d5a5ea029e97b5ac31a327e1803b",
  },
  mutations: {
    setActivePlan(state, plan) {
      state.activePlan = plan;
    },
    async setPlans(state, plans) {
      const styles = {};
      plans.map((element) => {
        styles[element._id] = element;
      });

      const benefitsRequest = await axios.get(
        `${state.API_URL}/collections/get/PremiumBenefits?&populate=1&token=${state.API_TOKEN}`
      );
      const benefits = {};
      benefitsRequest.data.entries.map((element) => {
        benefits[element._id] = element;
      });

      const premiumPlanTypeRequest = await axios.get(
        `${state.API_URL}/collections/get/PremiumPlanType?&populate=1&token=${state.API_TOKEN}`
      );
      const premiumPlanTypes = {};
      premiumPlanTypeRequest.data.entries.map((element) => {
        premiumPlanTypes[element._id] = element;
      });

      const premiumPlanRequest = await axios.get(
        `${state.API_URL}/collections/get/PremiumPlan?&populate=1&token=${state.API_TOKEN}`
      );
      const premiumPlans = {};
      premiumPlanRequest.data.entries.map((element) => {
        premiumPlans[element._id] = element;
      });

      const premiumplanTypes = [].concat(
        ...plans.map((plan) => {
          return plan.Types;
        })
      );
      const premiumPlansTypes = premiumplanTypes.filter((type) => {
        return type.PremiumPlanType;
      });
      const now = new Date().getTime();
      for (let index = 0; index < plans.length; index++) {
        const element = plans[index];
        if (
          ["Single Game Tickets", "Large Group Tickets", "Group Tickets Info"].includes(
            element.FullTitle
          )
        ) {
          //This dynamically adds the sgt and lgt pages if they are set to launched
          const pageMap = {
            "Single Game Tickets": {
              path: "single-game-tickets",
              path2: "game-tickets",
              name: "Single Game Tickets",
              name2: "",
              type: "single",
            },
            "Large Group Tickets": {
              path: "group-tickets",
              path2: "group-seating",
              name: "Group Tickets",
              name2: "Group Seating",
              type: "large-group",
            },
            "Group Tickets Info": {
              path: "group-tickets-info",
              path2: "group-seating-info",
              name: "Group Tickets Info",
              name2: "Group Seating Info",
              type: "group-tickets-info",
            },
          };
          let routes = [];
          const page = pageMap[element.FullTitle] ?? {};
          switch (element.FullTitle) {
            case "Single Game Tickets":
              routes.push({
                path: `/${page.path}`,
                name: `${page.name} - Type Of Plan`,
                component: () => import("@/views/PlanTypes"),
                props: {
                  type: page.type,
                },
              });                       
            case "Large Group Tickets":
              routes.push({
                path: `/${page.path}`,
                name: `${page.name} - Style Of Plan`,
                component: () => import("@/views/PlanTypes"),
                props: {
                  type: page.type,
                },
              });
            case "Single Game Tickets":
            case "Large Group Tickets":
              routes.push({
                path: `/${page.path}/special-events`,
                name: `${page.name} - Special Events`,
                component: () =>
                  page?.type === "large-group"
                    ? import("@/views/EventTickets1Col")
                    : import("@/views/EventTickets"),
                props: {
                  type: page.type,
                },
              });
              routes.push({
                path: `/${page.path}/${page.path2}`,
                name:
                  page.name2 === ""
                    ? page.name
                    : `${page.name} - ${page.name2}`,
                component: () => import("@/views/GameTickets"),

                props: {
                  type: page.type,
                },
              });
              break;
              case "Group Tickets Info":
                console.log(page, 'hello')
                routes.push({
                  path: `/${page.path}`,
                  name: `${page.name}`,
                  component: () => import("@/views/PlanTypes"),
                  props: {
                    type: page.type,
                  },
                }); 

            default:
              break;
          }

          routes.forEach((element) => {
            router.addRoute(element);
          });
        }
      }

      for (let index = 0; index < premiumPlansTypes.length; index++) {
        const element = premiumPlansTypes[index];
        const planStyle = (element.Style = styles[element.Style._id]);
        const premiumPlanType = (element.PremiumPlanType =
          premiumPlanTypes[element.PremiumPlanType._id]);
        premiumPlanType.Headers = premiumPlanType.Headers.map((element) => {
          let header = element.value;
          header = benefits[header._id];
          return header;
        });
        const basePath = planStyle.Title?.split(" ").join("-").toLowerCase();
        const path = premiumPlanType.Title?.split(" ").join("-").toLowerCase();
        const pathNotLaunched =
          new Date(`${element.LaunchDate} EST`).getTime() > now;
        //console.log('element', pathNotLaunched, element)
        if (state.liveMode && pathNotLaunched) {
          continue;
        }
        let route = {
          path: `/${basePath}/${path}`,
          name: premiumPlanType.Title,
          component: () => import("@/views/Comparison"),
          props: {
            plans: premiumPlanType,
          },
          meta: {},
        };
        router.addRoute(route);

        const PremiumPlan = premiumPlanType.PremiumPlan;
        for (let planIndex = 0; planIndex < PremiumPlan.length; planIndex++) {
          const premiumPlan = (PremiumPlan[planIndex] =
            premiumPlans[PremiumPlan[planIndex].value._id]);
          premiumPlan.Benefits = premiumPlan.Benefits.map((element) => {
            let benefit = element.value;
            benefit.Benefit = benefits[benefit.Benefit._id];
            return benefit;
          });
          premiumPlan.BonusPicks = premiumPlan.BonusPicks?.map((element) => {
            let benefit = element.value;
            benefit.Benefit = benefits[benefit.Benefit._id];
            return benefit;
          });
          let hasUpgrade = false;
          let hasDowngrade = false;
          if (premiumPlan.Upgrade || premiumPlan.ManualUpgradeLink) {
            hasUpgrade = true;
          }
          if (premiumPlan.Upgrade) {
            premiumPlan.Upgrade.Benefits = premiumPlan.Upgrade?.Benefits.map(
              (element) => {
                let benefit = element.value;
                benefit.Benefit = benefits[benefit.Benefit._id];
                return benefit;
              }
            );
          }
          if (premiumPlan.Downgrade) {
            hasDowngrade = true;
            premiumPlan.Downgrade.Benefits =
              premiumPlan.Downgrade?.Benefits.map((element) => {
                let benefit = element.value;
                benefit.Benefit = benefits[benefit.Benefit._id];
                return benefit;
              });
          }

          const planPath = premiumPlan.Title.split(" ").join("-").toLowerCase();
          let next = `${premiumPlan.Title} Summary`;
          let nextTitle = `${premiumPlan.Title}`;
          const bonusPickRoute = `${premiumPlan.Title} Bonus Pick${
            premiumPlan.BonusPicks?.length === "1" ? "" : "s"
          }`;
          if (premiumPlan.BonusPicks?.length > 0) {
            route = {
              path: `/${basePath}/${path}/${planPath}/bonus`,
              name: bonusPickRoute,
              component: () => import("@/views/Bonus"),
              props: {
                plan: premiumPlan.Title,
                numBonusPicks: premiumPlan.NumberOfBonusPicks,
                bonusPicks: premiumPlan.BonusPicks,
                next: next,
              },
              meta: {
                smallBackButton: true,
                ctaText: hasUpgrade
                  ? "Want More Benefits?"
                  : "Looking For All Inclusive Options?",
                showChatButton: hasUpgrade ? false : true, //show chat button if plan has no upgrade path
                showUpgradeButton: hasUpgrade ? true : true,
              },
            };
            router.addRoute(route);
            next = bonusPickRoute; //set next to bonus route for benefits page if bonus exists; otherwise Benefits links to summary page
            nextTitle = "View Bonus Pick Options";
          }

          route = {
            path: `/${basePath}/${path}/${planPath}`,
            name: `${premiumPlan.Title}`,
            component: () => import("@/views/Benefits"),
            props: {
              plan: premiumPlan.Title,
              additionalBenefits: premiumPlan.Benefits.filter((benefit) => {
                return benefit["Additional Benefit"] == true;
              }),
              rewards: premiumPlan.Rewards,
              experiences: premiumPlan.Experiences,
              bonusPicks: premiumPlan.NumberOfBonusPicks,
              next: next,
              nextTitle: nextTitle,
            },
            meta: {
              smallBackButton: true,
              ctaText: hasUpgrade
                ? "Want More Benefits?"
                : "Looking For All Inclusive Options?",
              showChatButton: hasUpgrade ? false : true, //show chat button if plan has no upgrade path
              showUpgradeButton: hasUpgrade ? true : true,
            },
          };
          router.addRoute(route);

          route = {
            path: `/${basePath}/${path}/${planPath}/summary`,
            name: `${premiumPlan.Title} Summary`,
            component: () => import("@/views/Summary"),
            props: {
              plan: premiumPlan.Title,
              planInfo: premiumPlan,
              games: premiumPlanType.Games,
              rewards: premiumPlan.Rewards,
              experiences: premiumPlan.Experiences,
            },
            meta: {
              smallBackButton: true,
            },
          };
          router.addRoute(route);
        }
      }

      const resolveRouted = router.resolve(router.currentRoute.value.path);
      //console.log('resolve', resolveRouted.name)
      router.push({
        name: resolveRouted.name,
        query: router.currentRoute.value.query,
      });
      state.plans = plans;
    },
  },
  actions: {},
  modules: {},
});
